import { takeEvery } from 'redux-saga/effects';

import { sagaApiGenWithPromise } from 'utils/sagaApiGeneratorHelpers';

import * as usersAPI from '../api/audio';
import {
  audioGetAll,
  audioGetAllFailed,
  audioGetAllSucceeded,
} from '../reducers/audio';

// Saga
export const audioSagas = [
  takeEvery(
    audioGetAll.toString() as any,
    sagaApiGenWithPromise(
      usersAPI.getAudios,
      audioGetAllSucceeded,
      audioGetAllFailed,
    ),
  ),
];
